import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { commonUtil } from '@roosevelt/common-ui-lib/core';

const loginStatus = sessionStorage.getItem('loginStatus');

if (!loginStatus) {
  sessionStorage.setItem('loginStatus', 'TRYING_EXISTING');
}

const baseUrl = window.location.pathname.split('/')[1];

commonUtil.bootstrap(
  fetch(baseUrl !== 'fgp' ? environment.configFile : environment.configFileFgp),
  platformBrowser,
  AppModule)
  .catch(err => console.error(err));
